import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import ModalPopup from "../../Common/Modal/Modal";

import {
  encryptVaultSecret,
  decryptVaultSecret,
} from "../../Common/Encrypt-Decrypt";

import {
  SendCredentialSecretKey,
  ValidateCredentialSecretKey,
} from "../../../Api/SuperAdminVault/Credentials";

const SecretAccessModal = ({
  show,
  credId,
  otpPurpose,
  mode = "view",
  onClose,
  onSuccess,
  verified,
  setVerified,
}) => {
  const inputRefs = useRef([]);

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(30);
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(true);

  const [secret, setSecret] = useState("");
  const [secretTimer, setSecretTimer] = useState(30);

  useEffect(() => {
    if (!show) return;

    setOtp(["", "", "", "", "", ""]);
    setTimer(30);
    setVerified(false);
    setSecret("");
    setChecking(true);

    sendOtp();

    setTimeout(() => {
      inputRefs.current[0]?.focus();
    }, 200);
  }, [show]);

  useEffect(() => {
    if (!show || verified || timer <= 0) return;

    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [show, verified, timer]);

  useEffect(() => {
    if (!verified) return;

    setSecretTimer(30);

    const interval = setInterval(() => {
      setSecretTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          handleClose();
          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [verified]);

  const formatTimer = () => {
    const min = String(Math.floor(timer / 60)).padStart(2, "0");
    const sec = String(timer % 60).padStart(2, "0");
    return `${min}:${sec}`;
  };

  const sendOtp = async () => {
    setLoading(true);

    const response = await SendCredentialSecretKey(credId, otpPurpose);

    if (response?.data?.[0]?.secret_encrypted) {
  const decryptedSecret = await decryptVaultSecret(
  response.data[0].secret_encrypted,
);

      setSecret(decryptedSecret);
      setVerified(true);
      onSuccess?.(decryptedSecret);
      setChecking(false);
      setLoading(false);
      return;
    }

    if (response?.success) {
      setOtp(["", "", "", "", "", ""]);
      setTimer(30);

      setTimeout(() => {
        inputRefs.current[0]?.focus();
      }, 200);
    }

    setChecking(false);
    setLoading(false);
  };

  const handleResendOtp = async () => {
    await sendOtp();
  };

  const handleChange = (index, value) => {
    const digit = value.replace(/\D/g, "").slice(0, 1);

    const updatedOtp = [...otp];
    updatedOtp[index] = digit;
    setOtp(updatedOtp);

    if (digit && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleVerifyOtp = async () => {
    const plainOtp = otp.join("");

    if (plainOtp.length !== 6) {
      toast.error("Enter valid 6 digit OTP");
      return;
    }

    setLoading(true);

    try {
      const encryptedOtp = await encryptVaultSecret(plainOtp);

      const response = await ValidateCredentialSecretKey({
        otp: encryptedOtp,
        cred_id: String(credId),
        otp_purpose: otpPurpose,
      });

      if (response?.data?.[0]?.secret_encrypted) {
        const decryptedSecret = await decryptVaultSecret(
          response.data[0].secret_encrypted,
        );

        setSecret(decryptedSecret);
        setVerified(true);
        onSuccess?.(decryptedSecret);
      } else {
        toast.error(response?.message || "OTP verification failed");
      }
    } catch (error) {
      console.error(error);
      toast.error("OTP verification failed");
    }

    setLoading(false);
  };

  const handleClose = () => {
    setOtp(["", "", "", "", "", ""]);
    setTimer(30);
    setVerified(false);
    setSecret("");

    onClose?.();
    console.log("back pressed 1");
  };

  return (
    <ModalPopup
      show={show}
      onClose={handleClose}
      width={verified ? "36vw" : ""}
      height={verified ? "16vw" : ""}
      closeicon={false}
    >
      {checking ? (
        <div className="h-[10vw] w-[30vw] flex items-center justify-center">
          <p className="text-[#1F487C] text-[1.1vw] font-semibold">
            Loading...
          </p>
        </div>
      ) : !verified ? (
        <div className="h-full flex flex-col">
          <div className="flex items-center justify-between">
            <button
              className="bg-[#1f4b7f] text-white pl-4 pr-2 py-1 rounded-r-md back-button"
              onClick={handleClose}
            >
              Back
            </button>

            {/* <button
              disabled={timer > 0}
              onClick={handleResendOtp}
              className={`text-[1vw] ${
                timer > 0
                  ? "text-[#1F487C] cursor-not-allowed"
                  : "text-[#1F487C] cursor-pointer font-bold"
              }`}
            >
              {timer > 0 ? `Resend OTP in ${formatTimer()}` : "Resend OTP"}
            </button> */}
          </div>

          <div className="flex flex-col items-center mt-[1.5vw]">
            <h1 className="text-[#1F487C] text-[1.5vw] font-bold">
              OTP Verification
            </h1>

            <p className="text-[1vw] mt-[1vw] text-black w-[24vw]">
              Enter the 6-digit OTP sent to your registered mobile number.
            </p>

            <div className="flex gap-[0.7vw] mt-[1.2vw]">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  ref={(el) => (inputRefs.current[index] = el)}
                  value={digit}
                  maxLength={1}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  className="w-[2.1vw] h-[2.1vw] text-center text-[1.2vw] border-[#9CA3AF] border-[0.12vw] rounded-[0.35vw] outline-none focus:border-[#1F487C]"
                />
              ))}
            </div>

            <button
              disabled={loading}
              onClick={handleVerifyOtp}
              className="bg-[#1F487C] text-white text-[1vw] px-[0.9vw] py-[0.45vw] rounded-[0.4vw] mt-[1vw]"
            >
              {loading ? "Verifying..." : "Verify & View"}
            </button>
          </div>
        </div>
      ) : (
        <div className="h-full flex flex-col">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-[1.5vw] font-bold text-[#1F487C]">
                Password
              </h1>
              <p className="text-[0.85vw] text-[#7C879D] font-semibold mt-[0.2vw]">
                This modal closes in {secretTimer}s
              </p>
            </div>

            <button
              onClick={handleClose}
              className="bg-[#1F487C] text-white text-[1vw] px-[1vw] py-[0.4vw] rounded-[0.4vw]"
            >
              Close
            </button>
          </div>

          <div className="mt-[1.2vw] bg-[#E9EEF5] border-[#1F487C] border-r-[0.25vw] border-b-[0.25vw] border-l-[0.1vw] border-t-[0.1vw] rounded-[0.6vw] min-h-[5vw] p-[1vw] break-all flex items-center">
            <p className="text-[#1F487C] text-[1.1vw] font-semibold leading-[1.5vw]">
              {secret}
            </p>
          </div>

          <div className="mt-[1vw] w-full bg-gray-200 rounded-full h-[0.45vw] overflow-hidden">
            <div
              className="bg-[#1F487C] h-full rounded-full transition-all duration-1000"
              style={{ width: `${(secretTimer / 30) * 100}%` }}
            />
          </div>
        </div>
      )}
    </ModalPopup>
  );
};

export default SecretAccessModal;
